export default __webpack_public_path__ + "static/ceinture3.inspirations-255219f892a69fc185504e13a2e5ca9c.jpg";